
import Modal from 'react-modal';
import {useState} from "react";
import { useTranslation } from "react-i18next";

export const WorkingHours = () => {
    const { t } = useTranslation();

    const customStyles = {
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          border: '0.5px solid #f3a46e',
          width: "50%"
        },
      };

      function openModal() {
        setIsOpen(true);
      }
    
      function closeModal() {
        setIsOpen(false);
      }

      const [modalIsOpen, setIsOpen] = useState(false);

      return (
        <div>
        <button onClick={openModal} className="working_hrs_btn">{t('btn_working_hrs')}</button>
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"

        >
        <div className="title_row">
            <h2>{t("btn_working_hrs")}</h2>
            <button onClick={closeModal} className="button_close">X</button>
        </div>
       
        <div>
            <p className="row_spacing">{t("mon_thu")}</p>
            <p className = "texts">{t("fri")}</p>
        </div>
      </Modal>
        </div>
        )

}